import { render, staticRenderFns } from "./Rodape.vue?vue&type=template&id=5a457a06&"
import script from "./Rodape.vue?vue&type=script&lang=ts&"
export * from "./Rodape.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports